import { getBusiness, getType } from "@/data/business";

export const EVENT_TYPES = new Proxy([], { get(_, p) { const t = getType(getBusiness().type).eventTypes; const v = t[p]; return typeof v === "function" ? v.bind(t) : v; } });
export const EVENT_SPACES = new Proxy([], { get(_, p) { const t = getBusiness().spaces; const v = t[p]; return typeof v === "function" ? v.bind(t) : v; } });

export const DEFAULT_TIMELINE = [
  { time: "09:00", what: "Allestimento sala e prato: tavoli, mise en place, fiori", who: "Sala" },
  { time: "10:00", what: "Consegne fornitori, controllo materie prime", who: "Cucina" },
  { time: "11:30", what: "Briefing di 10 minuti: scaletta, allergie, tavolo degli sposi, imprevisti", who: "Responsabile" },
  { time: "12:30", what: "Arrivo ospiti, aperitivo e finger food", who: "Sala + Cucina" },
  { time: "13:30", what: "Ingresso a tavola, via al servizio antipasti", who: "Sala" },
  { time: "14:00", what: "Primi: uscita sincronizzata per tavolo", who: "Cucina" },
  { time: "15:00", what: "Secondi e contorni", who: "Cucina" },
  { time: "16:00", what: "Taglio torta, buffet dolci, caffè", who: "Sala" },
  { time: "17:30", what: "Saluti, sbarazzo, riordino cucina, conteggio rimanenze", who: "Tutti" },
];

export const DEFAULT_BRIEFING = [
  "Chi è il referente del cliente oggi e dove si trova",
  "Numero esatto di coperti e bambini; tavoli con allergie/intolleranze",
  "Scaletta e orari: chi dà il via a ogni portata",
  "Piano B in caso di pioggia (prato → sala)",
  "Chi chiama chi in caso di problema: una sola persona parla con il cliente",
];

export const DEFAULT_CHECKLIST = [
  "Preventivo firmato e acconto ricevuto",
  "Menù definitivo confermato con il cliente",
  "Lista allergie e intolleranze in cucina e in sala",
  "Ordini ai fornitori confermati",
  "Personale extra confermato (nome, orario, ruolo)",
  "Allestimenti, fiori, musica: orari di arrivo",
  "Camere pronte per gli ospiti che dormono",
  "Piscina e prato in ordine, piano pioggia pronto",
];

export const newEvent = () => ({
  id: crypto.randomUUID(),
  businessId: getBusiness().id,
  createdAt: new Date().toISOString(),
  title: "",
  date: "",
  type: EVENT_TYPES[0],
  guests: "",
  spaces: EVENT_SPACES.slice(0, 2),
  client: "",
  roles: { sala: "", cucina: "", extraSala: "", extraCucina: "" },
  menu: "",
  timeline: DEFAULT_TIMELINE.map((r) => ({ ...r })),
  briefing: [...DEFAULT_BRIEFING],
  checklist: DEFAULT_CHECKLIST.map((text) => ({ text, done: false })),
  notes: "",
  costs: { pricePerCover: "", foodPerCover: "", staff: "", extras: "", other: "" },
});

export const computeMargin = (ev) => {
  const n = Number(ev.guests) || 0;
  const c = ev.costs || {};
  const num = (v) => Number(v) || 0;
  const revenue = n * num(c.pricePerCover);
  const food = n * num(c.foodPerCover);
  const total = food + num(c.staff) + num(c.extras) + num(c.other);
  const margin = revenue - total;
  return { revenue, food, total, margin, pct: revenue > 0 ? Math.round((margin / revenue) * 100) : 0, perCover: n > 0 ? Math.round(margin / n) : 0 };
};

const eur = (v) => (Number(v) || 0).toLocaleString("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 });

export const economicsBlocks = (ev) => {
  const c = ev.costs || {};
  const n = Number(ev.guests) || 0;
  const m = computeMargin(ev);
  const q = ev.quote || {};
  const price = Number(c.pricePerCover) || 0;
  const extrasPrice = Number(q.extrasPrice) || 0;
  const total = n * price + extrasPrice;
  const deposit = Math.round((total * (Number(q.depositPct) || 0)) / 100);
  const costs = { heading: "Scheda costi e margine", rows: [
    ["Coperti", n], ["Prezzo per coperto", eur(price)], ["Food cost per coperto", eur(c.foodPerCover)], ["Personale", eur(c.staff)], ["Extra (allestimenti, noleggi)", eur(c.extras)], ["Altri costi", eur(c.other)],
    ["Ricavo previsto", eur(m.revenue)], ["Costi totali", eur(m.total)], ["Margine previsto", `${eur(m.margin)} (${m.pct}%) · ${eur(m.perCover)} a coperto`],
  ] };
  const quote = { heading: "Preventivo", rows: [
    ...(q.number ? [["Numero", q.number]] : []), ["Totale al cliente", eur(total)], ...(extrasPrice ? [[q.extrasText || "Servizi aggiuntivi", eur(extrasPrice)]] : []),
    ...(q.depositPct ? [[`Acconto ${q.depositPct}%`, eur(deposit)], ["Saldo", eur(total - deposit)]] : []), ...(q.validityDays ? [["Validità", `${q.validityDays} giorni`]] : []),
    ...(q.includes ? [["La proposta comprende", q.includes]] : []),
  ] };
  return price || m.total ? [costs, quote] : [];
};

const KEY = "cmm_eventi";
export const loadEvents = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
};
export const getEvent = (id) => loadEvents().find((e) => e.id === id) || null;
export const upsertEvent = (ev) => {
  const list = loadEvents();
  const i = list.findIndex((e) => e.id === ev.id);
  if (i >= 0) list[i] = ev;
  else list.unshift(ev);
  localStorage.setItem(KEY, JSON.stringify(list));
  return ev;
};
export const removeEvent = (id) => localStorage.setItem(KEY, JSON.stringify(loadEvents().filter((e) => e.id !== id)));
